import { useApiUrl, useCustom } from "@pankod/refine-core";

import { AuditLogMetadata } from "../types";

export const AUDIT_LOG_METADATA_RESOURCE = "v1/audit-log/metadata";

export const useAuditLogMetadata = () => {
  const apiUrl = useApiUrl();

  return useCustom<AuditLogMetadata>({
    url: `${apiUrl}/${AUDIT_LOG_METADATA_RESOURCE}`,
    method: "get",
  });
};